export default {"src":"/_next/static/media/stakecut-logo-dark.c8f278cc.svg","height":30,"width":122};